import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { Dossier } from '@sc/data-access-models';

import {
  ReplaceDossiersToValidateAction,
  SetDossiersToValidateAction,
  SetNewDossiersToValidateAction,
} from './dossiers-to-validate.actions';

export const DossiersToValidateStateKey: Readonly<string> =
  'dossiersToValidate';
export const DossiersToValidateStateDefault: Dossier[] = [];

@State<Dossier[]>({
  name: DossiersToValidateStateKey,
  defaults: DossiersToValidateStateDefault,
})
@Injectable()
export class DossiersToValidateState {
  @Action(SetDossiersToValidateAction)
  setDossiers(
    ctx: StateContext<Dossier[]>,
    { payload }: SetDossiersToValidateAction
  ): void {
    ctx.setState(payload);
  }

  @Action(SetNewDossiersToValidateAction)
  setNewDossier(
    ctx: StateContext<Dossier[]>,
    { payload }: SetNewDossiersToValidateAction
  ): void {
    const state = ctx.getState() ? [...ctx.getState()] : [];

    state.push(...payload);

    ctx.setState(state);
  }

  @Action(ReplaceDossiersToValidateAction)
  replaceDossiers(
    ctx: StateContext<Dossier[]>,
    { payload }: ReplaceDossiersToValidateAction
  ): void {
    let state = ctx.getState() ? [...ctx.getState()] : [];

    state = state.filter(
      (stateDossier) =>
        payload.findIndex(
          (payloadDossier) => payloadDossier.id === stateDossier.id
        ) === -1
    );

    state.push(...payload);

    ctx.setState(state);
  }
}
